<div mdbModal #verPago="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="width: 80%" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Detalle pago
        </h4>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verPago.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row filtros-body">
          <div class="col">
            <h5>Documento pendiente por pagar</h5>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Nro. Doc</th>
                <th scope="col">Emisión</th>
                <th scope="col">Vencimiento</th>
                <th scope="col" class="text-right">Monto</th>
                <th scope="col" class="text-right">Pago</th>
                <th scope="col" class="text-right">Deuda</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngIf="loading">
                    <td colspan="100%" style="text-align: center">
                        <mdb-spinner spinnerColor="blue"></mdb-spinner>
                    </td>
                </tr>
                <tr *ngIf="!loading && pago?.saldoDocumento.length === 0">
                    <td colspan="100%" style="text-align: center">
                        No se encontró información
                    </td>
                </tr>
                <tr *ngFor="let mov of pago?.saldoDocumento">
                    <!-- <td>
                        <mdb-checkbox></mdb-checkbox>
                    </td> -->
                    <td>{{mov.folio}}</td>
                    <td>{{mov.tipo_pago}}</td>
                    <td>{{mov.fecha_emision | fecha}}</td>
                    <td align="right">$ {{mov.monto | numerico}}</td>
                    <td align="right">$ {{mov.pago | numerico}}</td>
                    <!-- <td style="width: 100px;" align="right">
                        <input type="text" id="input11" class="form-control" placeholder=""
                            [(ngModel)]="mov.abono" onlyNumbers />
                    </td> -->
                    <td align="right">$ {{mov.saldo | numerico}}</td>
                    <!-- <td></td> -->
                    <!-- <td></td> -->
                </tr>
            </tbody>
            <tbody class="blue lighten-5" *ngIf="pago?.saldoDocumento.length > 0">
              <tr>
                <td align="right" colspan="3"><strong>Totales</strong></td>
                <td align="right"><strong>$ {{pago.totales.saldoDocumento.monto | numerico}}</strong></td>
                <td align="right"><strong>$ {{pago.totales.saldoDocumento.pago | numerico}}</strong></td>
                <td align="right"><strong>$ {{pago.totales.saldoDocumento.saldo | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row filtros-body" *ngIf="pago?.canjeDocumento.length > 0">
          <div class="col">
            <h5>Factura usadas de canje</h5>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Nro. Doc.</th>
                  <th scope="col">Emisión</th>
                  <th scope="col">Vencimiento</th>
                  <th scope="col" class="text-right">Monto</th>
                </tr>
              </thead>
              <tbody>
                  <tr *ngIf="loading">
                      <td colspan="100%" style="text-align: center">
                          <mdb-spinner spinnerColor="blue"></mdb-spinner>
                      </td>
                  </tr>
                  <!-- <tr *ngIf="!loading && pago?.canjeDocumento.length === 0">
                      <td colspan="100%" style="text-align: center">
                          No se encontró información
                      </td>
                  </tr> -->
                <tr *ngFor="let mov of pago?.canjeDocumento">
                  <td>{{mov.folio}}</td>
                  <td>{{mov.fecha_emision | fecha}}</td>
                  <td>{{mov.fecha_emision | fecha}}</td>
                  <td align="right">$ {{mov.saldo}}</td>
                </tr>
              </tbody>
              <!-- <tbody class="blue lighten-5" *ngIf="pago?.canjeDocumento.length > 0">
                <tr>
                  <td align="right" colspan="3">
                    <strong>Total en factura de canje usadas</strong>
                  </td>
                  <td align="right"><strong>200</strong></td>
                </tr>
              </tbody> -->
            </table>
          </div>
        </div>

      <br>
        <div class="row filtros-body">
          <div class="col">
            <h5>Formas de pago</h5>
          </div>
        </div>
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" colspan="3">Descripción</th>
                <th scope="col">Nro. </th>
                <th scope="col" class="text-center">Banco</th>
                <th scope="col" class="text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngIf="loading">
                    <td colspan="100%" style="text-align: center">
                        <mdb-spinner spinnerColor="blue"></mdb-spinner>
                    </td>
                </tr>
                <tr *ngIf="!loading && pago?.forma_pago.length === 0">
                    <td colspan="100%" style="text-align: center">
                        No se encontró información
                    </td>
                </tr>
                <tr *ngFor="let mov of pago?.forma_pago">
                    <!-- <td>
                        <mdb-checkbox></mdb-checkbox>
                    </td> -->
                    <td colspan="3">{{mov.tipo_pago_nombre}}</td>
                    <td>
                        <ng-container *ngIf="mov.numero_doc > 0">
                            {{mov.numero_doc}}
                        </ng-container>
                    </td>
                    <td class="text-center">{{ mov.banco_nombre }}</td>
                    <td align="right">$ {{mov.monto | numerico}}</td>
                </tr>
            </tbody>
            <tbody class="blue lighten-5" *ngIf="pago?.forma_pago.length > 0">
              <tr>
                <td align="right" colspan="5">
                  <strong>Total forma de pago</strong>
                </td>
                <td align="right"><strong>$ {{pago.totales.forma_pago | numerico}}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="verPago.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
